<template>
  <div>
    <h1 class="m-0 mb-4 billing-history-title">
      {{ $t('pages.billing.transaction') }}
    </h1>

    <div class="table-scroll-wrapper">
      <el-table
        :data="getPaymentHistory"
        stripe
        class="table-normalize"
      >
        <el-table-column
          prop="created_at"
          :label="`${$t('dialogs.paymentHistory.tableColumns.date')}`"
          align="center"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="customer_name"
          align="center"
          :label="`${$t('dialogs.paymentHistory.tableColumns.profileOwner')}`"
        />
        <el-table-column
          :label="`${$t('dialogs.paymentHistory.tableColumns.pricePlan')}`"
          align="center"
          width="200"
          :formatter="formatter"
        />
        <el-table-column
          prop="currency"
          :label="`${$t('dialogs.paymentHistory.tableColumns.currency')}`"
          align="center"
          width="90"
        />
        <!--<el-table-column
                prop="payment_tax"
                label="VAT"
                align="center"
              >
              </el-table-column>-->
        <el-table-column
          prop="sale_gross"
          :label="`${$t('dialogs.paymentHistory.tableColumns.totalAmount')}`"
          width="130"
          align="center"
        />
        <el-table-column
          prop="receipt_url"
          :label="`${$t('dialogs.paymentHistory.tableColumns.invoice')}`"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            <a class="billing-download-link" :href="scope.row.receipt_url" target="_blank">{{ $t('dialogs.paymentHistory.download') }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import paymentTypes from '@/data/paymentTypes.json'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BillingHistory',

  data () {
    return {
      paymentHistory: [],
      paymentHistoryData: null
    }
  },

  computed: {
    ...mapGetters('user/paymentHistory', ['getPaymentHistory'])
  },

  async mounted () {
    this.loadPaymentHistoryData()
  },

  methods: {
    ...mapActions('user/paymentHistory', ['fetchPaymentHistory']),

    loadPaymentHistoryData () {
      this.fetchPaymentHistory().catch(() => {
        this.$notify({
          title: 'Error',
          dangerouslyUseHTMLString: true,
          message: 'Something went wrong <br>Please try again latter!',
          type: 'error'
        })
      })
    },

    dateFormatter (row, column, cellValue) {
      return cellValue.slice(0, 10)
    },

    formatter (row) {
      const planSlug = row.slug
      const planType = paymentTypes[row.type]
      const planIdeas = row.ideas > 1 ? row.ideas + ' ideas' : row.ideas + ' idea'

      return planSlug + ' / ' + planIdeas + ' / ' + planType
    }
  }
}
</script>

<style scoped lang="scss">
.table-scroll-wrapper {
  max-height: 500px;
  overflow-y: auto;
}

.billing-history-title {
  font-size: 24px;
}

.billing-download-link {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #292f4d;
  padding-bottom: 2px;
}

.billing-download-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: currentColor;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.billing-download-link:hover::after {
  transform: scaleX(1);
}
</style>
